export enum UserActions {
  LOGOUT = '[UserActions] LOGOUT',
}
